// src/screens/Helpscore/HelpScoreForm.js
import React, { useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import useHelpScore from '../../hooks/useHelpScore'
import Question from '../../components/helpScore/Question'
import './HelpScoreForm.css'
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner'
import mHaderechLogo from '../../assets/M-Haderech-logo.png'


const Credits = () => (
	<div style={{
		textAlign: 'right',
		direction: 'rtl',
		marginTop: '32px',
		marginRight: '0',
		fontSize: '0.95em',
		color: '#555'
	}}>
		<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '18px', flexWrap: 'wrap', paddingBottom: '16px' }}>
			<span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
				כל הזכויות שמורות לעמותת HER
				<a href="https://www.hyperemesis.org/" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline', display: 'flex', alignItems: 'center', gap: '6px', marginRight: '4px' }}>
					HER
					<img src={require('../../assets/image.png')} alt="HER" style={{ width: '32px', height: '32px', borderRadius: '6px', marginRight: '4px' }} />
				</a>
			</span>
			<span style={{
				width: '8px', height: '8px', background: '#bbb', borderRadius: '50%', display: 'inline-block', margin: '0 8px'
			}}></span>
			<span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
				מקור מבדק HELP נלקח מאתר של
				<a href="https://www.chavalimsheli.org/" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'underline', display: 'flex', alignItems: 'center', gap: '6px', marginRight: '4px' }}>
					חבלים שלי
					<img src={require('../../assets/1-a40fd836.jpg')} alt="חבלים שלי" style={{ width: '32px', height: '32px', objectFit: 'cover', borderRadius: '6px', marginRight: '4px' }} />
				</a>
			</span>
		</div>
	</div>
)

const HelpScoreForm = () => {
	const { questions, description, loading, error } = useHelpScore()
	const [answers, setAnswers] = useState({})
	const [validationError, setValidationError] = useState(null)
	const [shake, setShake] = useState(false)
	const navigate = useNavigate()
	const errorMessageRef = useRef(null)

	const handleRadioChange = (questionId, selectedValue) => {
		setAnswers((prevAnswers) => ({
			...prevAnswers,
			[questionId]: selectedValue,
		}))
	}

	const handleSubmit = (e) => {
		e.preventDefault()

		const allQuestions = document.querySelectorAll('.q-container')
		allQuestions.forEach((questionElement) => {
			questionElement.classList.remove('req_question')
		})

		const unansweredRequiredQuestions = questions.filter(
			(question) => question.required && !answers[question.id]
		)

		if (unansweredRequiredQuestions.length > 0) {
			unansweredRequiredQuestions.forEach((question) => {
				const questionElement = document
					.getElementById(`question-${question.id}`)
					.closest('.q-container')
				if (questionElement) {
					questionElement.classList.add('req_question')
				}
			})
			setValidationError('כדי לקבל תוצאות, אי אפשר לדלג על השאלות המסומנות ב*')
			setShake((prev) => !prev)
			if (errorMessageRef.current) {
				errorMessageRef.current.scrollIntoView({ behavior: 'smooth' })
			}
			return
		}

		setValidationError(null)
		navigate('/calculateHelpScore', { state: { answers } })
	}

	return (
		<>
			<div className='help-score-page-wrapper'>
				<a href='https://hg-emhaderech.org.il/' target='_blank' rel='noopener noreferrer' className='logo-link'>
					<img src={mHaderechLogo} alt='אם הדרך' className='page-logo' />
				</a>
				<form onSubmit={handleSubmit} className='help-score-form'>
					<title>מבדק היפרמאזיס (HG) אישי</title>
					<meta name='description' content='מבדק היפרמאזיס (HG) אישי' />
					{loading && <LoadingSpinner />}
					{error && <p>שגיאה: {error}</p>}
					{!loading && !error && (
						<>
							<div className='help-score-form-header'>
								<h2> ציון HELP ( חישוב חומרת היפראמזיס = Prediction Level HyperEmesis ) </h2>
								{description && <p className='questionnaire-description'>{description}</p>}
								<div className='bordered-container'>
									{questions.map((question) => (
										<Question
											key={question.id}
											question={question}
											onRadioChange={(option) => handleRadioChange(question.id, option)}
										/>
									))}
									<button type='submit'>שליחה</button>
								<div className='form-footer-notes'>
									<p>נוסחה לחישוב אחוז ירידה במשקל: % ירידה במשקל = (מספר הק"ג שירדת : משקל לפני הריון) X 100</p>
									<p>*מספר תרופות מרשם = מספר תרופות מרשם עבור היפראמזיס (לא מינון ולא סה"כ כדורים ליום)</p>
								</div>
								<table className='weight-loss-table'>
									<thead>
										<tr>
											<th>תוך זמן</th>
											<th>אחוז איבוד משקל - משמעותי</th>
											<th>אחוז איבוד משקל – חמור</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>שבוע אחד</td>
											<td>1-2%</td>
											<td>&gt; 2%</td>
										</tr>
										<tr>
											<td>חודש אחד</td>
											<td>5%</td>
											<td>&gt; 5%</td>
										</tr>
										<tr>
											<td>שלושה חודשים</td>
											<td>7.5%</td>
											<td>&gt; 7.5%</td>
										</tr>
									</tbody>
								</table>
									{validationError && (
										<p key={shake} ref={errorMessageRef} className='requiredFieldsErrorMsg'>
											{validationError}
										</p>
									)}
								</div>
							</div>
						</>
					)}
				</form>
			</div>
			<Credits />
		</>
	)
}

export default HelpScoreForm
